export const ACCOUNT_NOT_FOUND_TITLE = 'Conta não encontrada';

export const ACCOUNT_NOT_FOUND_MESSAGE =
  'Não existe conta do Bandplay para esse usuário. Se precisar de ajuda, fale com o nosso atendimento.';

export const ACCOUNT_NOT_FOUND_BUTTON = 'Entendi';

export const ACCOUNT_NOT_FOUND_TV_CLASS = 'account-not-found-modal';

export const ACCOUNT_NOT_FOUND_CLOSE_EVENT = 'close-account-not-found-modal';
